import MutedSuggestionsDrawer from './MutedSuggestionsDrawer.component';

export default MutedSuggestionsDrawer;